export const headerNavigation = [
  {
    label: 'developer_landing_header_navigation_developer_platform',
    path: '/developer/dashboard',
  },
  {
    label: 'developer_landing_header_navigation_api_documentation',
    path: 'https://greenwayhealth-group.readme.io/greenwayhealth/docs',
    target: '_blank',
  },  
  {
    label: 'developer_landing_header_navigation_application_gallery',
    path: '/app-gallery',
    target: '_blank',
  },
];

export const headerNavigationAdmin = [
  {
    label: 'developer_landing_header_navigation_api_documentation',
    path: 'https://greenwayhealth-group.readme.io/greenwayhealth/docs',
    target: '_blank',
  }, 
  {
    label: 'developer_landing_header_navigation_application_gallery',
    path: '/app-gallery',
    target: '_blank',
  },
];

export const headerNavigationRegistration = [
];
